import { isPrimaryControlsStripBackOverrideEntry } from "@-/dev.improve.haniverse.contexts.primary-controls-strip.back";
import { usePrimaryControlsStripBackRegistryCurrent } from "#use-primary-controls-strip-back-registry-current";

/** Whether a screen's `PrimaryControlsStripLeading` currently fills the app shell's top-left slot. */
export function usePrimaryControlsStripLeadingIsOverridden(): boolean {
  return isPrimaryControlsStripBackOverrideEntry(usePrimaryControlsStripBackRegistryCurrent());
}
